import React, {
  useState
} from 'react';
import SwiperCore, {
  Navigation,
  Pagination
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './about-company-view.module.scss';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTranslation } from 'next-i18next';

SwiperCore.use([Navigation, Pagination]);

const AboutCompanyView = () => {
  const { t } = useTranslation('landing');
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const onSlideNext = () => {
    if (currentSlideIndex < 3) {
      swiperInstance.slideTo(currentSlideIndex + 1);
      setCurrentSlideIndex(currentSlideIndex + 1);
    }
  }

  const onSlidePrev = () => {
    if (currentSlideIndex > 0) {
      swiperInstance.slideTo(currentSlideIndex - 1);
      setCurrentSlideIndex(currentSlideIndex - 1);
    }
  }

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <h1 className="page-title">{t('pages.aboutCompany.title')}</h1>
        <div className="page-description">
          ZEN.CAR (ООО Зенкар) резидент Особой экономической зоны Иннополис <a href="https://sezinnopolis.ru/residents/ooo-zenkar/" target="_blank">https://sezinnopolis.ru/residents/ooo-zenkar/</a >полностью автоматизирует бизнес-процессы станций технического обслуживания. Мы обеспечиваем поток клиентов с чётко сформулированными запросами на обслуживание/ремонт. Снижаем ваши затраты на маркетинг и рекламу. Вы можете сосредоточиться на том, чего от вас ждут автовладельцы, а именно, на качестве и клиентском сервисе.
          Программный продукт Workshop.zen.car собственная разработка и находится в реестре отечественного ПО: <a href="https://reestr.digital.gov.ru/reestr/364116/?sphrase_id=3421189" target="_blank">https://reestr.digital.gov.ru/reestr/364116/?sphrase_id=3421189</a>
        </div>
      </div>

      <div className={styles.content_container}>
        <div className={styles.bg_block} />
        <div id="mass-media" className={styles.mass_media_container}>
          <div className={styles.controls_row}>
            <h2 className="section-title">
              {t('pages.aboutCompany.publications')}
            </h2>
            <div className={styles.controls}>
              <div className={styles.swiper_control}>
                <div
                  className="button-prev"
                  onClick={onSlidePrev}
                >
                  <ArrowBackIcon />
                </div>
              </div>
              <div className={styles.swiper_control}>
                <div
                  className="button-next"
                  onClick={onSlideNext}
                >
                  <ArrowForwardIcon />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.swiper_container}>
            <div className={styles.hide_container}>
              <Swiper
                spaceBetween={40}
                slidesPerView={2}
                speed={500}
                pagination={{ clickable: true }}
                navigation={{
                  nextEl: ".button-next",
                  prevEl: ".button-prev"
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1
                  },
                  1100: {
                    slidesPerView: 2
                  }
                }}
                onSwiper={setSwiperInstance}
              >
                <SwiperSlide>
                  <div className={styles.article_container}>
                    <a href="http://www.russia-on.ru/154078?utm_source=LJ&utm_medium=LJ_RussiaOn&utm_campaign=snrusonsoc" target="_blank">
                      <div className={styles.article}>
                        <div className={styles.date}>
                          08.08.2021
                        </div>
                        <div className={styles.title}>
                          В Татарстане стартует новый проект для автовладельцев и СТО
                        </div>
                        <div className={styles.source}>
                          Россия-онлайн
                        </div>
                      </div>
                    </a>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.article_container}>
                    <a href="https://www.tatar-inform.ru/news/v-tatarstane-poyavilsya-oblachnyy-servis-po-remontu-avtomobiley" target="_blank">
                      <div className={styles.article}>
                        <div className={styles.date}>
                          15.04.2021
                        </div>
                        <div className={styles.title}>
                          В Татарстане появился облачный сервис по ремонту автомобилей
                        </div>
                        <div className={styles.source}>
                          TatarInform
                        </div>
                      </div>
                    </a>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.article_container}>
                    <a href="https://sezinnopolis.ru/novosti/zenkar-sozdaet-tsifrovye-servisy-dlya-avtovladeltsev-i-sto/" target="_blank">
                      <div className={styles.article}>
                        <div className={styles.date}>
                          12.04.2021
                        </div>
                        <div className={styles.title}>
                          «Зенкар» создает цифровые сервисы для автовладельцев и СТО
                        </div>
                        <div className={styles.source}>
                          ОЭЗ Иннополис
                        </div>
                      </div>
                    </a>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.article_container}>
                    <a href="https://rb.ru/news/innopolis-razrabotki/" target="_blank">
                      <div className={styles.article}>
                        <div className={styles.date}>
                          30.11.2020
                        </div>
                        <div className={styles.title}>
                          ZEN.CAR получил статус резидента города Иннополис
                        </div>
                        <div className={styles.source}>
                          Rusbase
                        </div>
                      </div>
                    </a>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.article_container}>
                    <a href="https://www.tadviser.ru/index.php/Компания:Зенкар_(Zen.Car)" target="_blank">
                      <div className={styles.article}>
                        <div className={styles.date}>
                          03.04.2019
                        </div>
                        <div className={styles.title}>
                          Компания «Дигинавис» стала соучредителем ZEN.CAR
                        </div>
                        <div className={styles.source}>
                          Tadviser
                        </div>
                      </div>
                    </a>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.article_container}>
                    <a href="https://kazan24.ru/news/useful/v-kazani-zapustilsya-proekt-zen-car-po-vyboru-avtoservisa" target="_blank">
                      <div className={styles.article}>
                        <div className={styles.date}>
                          10.08.2017
                        </div>
                        <div className={styles.title}>
                          В Казани запустился проект ZEN.CAR по выбору автосервиса
                        </div>
                        <div className={styles.source}>
                          Kazan24
                        </div>
                      </div>
                    </a>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div className={styles.hide_left} />
              <div className={styles.hide_left_2} />
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default AboutCompanyView;